const createAddress = () =>
  new Vue({
    data: () => {
      return {
        addressList: [],
        defaultId: "",
        userToken: "",
        showForm: false,
        countryUrl: "api/v1/area/list",
        completeAddressUrl: "web.ToolService/AddressAutoComplete",
        countries: [],
        searchValue: "",
        formData: {
          firstName: "",
          lastName: "",
          address1: "",
          address2: "",
          country: "",
          telephoneCode: "",
          telephone: "",
          province: "",
          city: "",
          zip: "",
        },
        matchAddresses: [],
        selectedCountry: null,
        selectedTelephone: null,
        showTelephoneDropdown: false,
        showCountryDropdown: false,
        showAddressDropdown: false,
        countryPlaceholder: "Choose Country",
        telPlaceholder: "Telephone Code",
        filterCountry: "",
        filterTelephone: "",
        debounceTimer: null,
        showSelectCountry: true,
        showSelectTelephone: true,
        formType: "add",
        errors: {},
        checkedDefault: false,
        showDeleteConfirm: false,
        addressToDelete: null,
      };
    },
    created() {
      this.userToken = JSON.parse(theme.getCookies("s_token"));
      this.init();
    },
    mounted() {
      document.addEventListener("click", this.handleClickTelOutside);
      document.addEventListener("click", this.handleClickCountryOutside);
      document.addEventListener("click", this.handleClickAddressOutside);
    },
    beforeDestroy() {
      document.removeEventListener("click", this.handleClickTelOutside);
      document.removeEventListener("click", this.handleClickCountryOutside);
      document.removeEventListener("click", this.handleClickAddressOutside);
    },
    computed: {
      filteredCountries() {
        return this.filterList(this.countries, this.filterCountry);
      },
      filteredTelephoneCodes() {
        return this.filterList(this.countries, this.filterTelephone);
      },
    },
    methods: {
      // 获取地址列表
      getData() {
        const gql = `
      {
        customer(customerAccessToken: "${this.userToken}") {
          addresses(first: 250) {
            pageInfo {
              hasNextPage
              hasPreviousPage
            }
            nodes {
              address1
              address2
              city
              company
              country
              countryCode
              firstName
              formattedArea
              id
              lastName
              latitude
              longitude
              name
              phone
              province
              provinceCode
              zip
            }
          }
          defaultAddress {
            id
          }
        }
      }
      `;
        fetchGraphQL(gql).then((data) => {
          const edges = data?.customer?.addresses?.nodes ?? [];
          this.addressList = edges;
          this.defaultId = data?.customer?.defaultAddress?.id;
          // console.log(this.defaultId);
        });
      },
      // 是否为默认地址
      defaultFlag() {
        return this.defaultId === this.formData.id || this.checkedDefault;
      },
      // 获取国家列表
      getCountryList() {
        const jsonString = localStorage.getItem("areaList");
        this.countries = theme.inspectJson(jsonString);
        if (this.countries?.length > 0) return;
        fetchRequest(this.countryUrl, "GET").then((response) => {
          if (!response.error) {
            this.countries = response.data;
          }
        });
      },
      // 初始化
      init() {
        this.getData();
        this.getCountryList();
      },
      // 提示成功信息
      showSuccessMessage() {
        const message = document.getElementById("promptMessage");
        message.classList.remove("hidden");
        message.classList.add("show");
        const timer = setTimeout(() => {
          clearTimeout(timer);
          message.classList.remove("show");
          message.classList.add("hidden");
          this.getData();
        }, 2000);
      },
      // 处理表单数据
      handleAddParams() {
        this.formData.country = this.selectedCountry?.iso2_code;
        this.formData.telephoneCode = this.selectedTelephone?.iso3_code;
        this.formData.phone = `${this.formData.telephoneCode} ${this.formData.telephone}`;
        return this.formData;
      },
      // 处理提交的表单数据
      handleFormParams() {
        // 定义需要保留的字段
        const allowedFields = [
          "firstName",
          "lastName",
          "address1",
          "address2",
          "country",
          "province",
          "city",
          "zip",
          "phone",
        ];
        const filteredData = Object.entries(this.formData).reduce(
          (acc, [key, value]) => {
            if (allowedFields.includes(key)) {
              acc[key] = value;
            }
            return acc;
          },
          {}
        );
        return filteredData;
      },
      // 新增或修改地址的query
      addressQuery() {
        return `
          mutation customerAddressUpdate(
            $address: MailingAddressInput!
            $customerAccessToken: String!
            $id: ID!
          ) {
            customerAddressUpdate(
              address: $address
              customerAccessToken: $customerAccessToken
              id: $id
            ) {
              customerAddress {
                id
              }
              customerUserErrors {
                message
                code
              }
              userErrors {
                field
                message
              }
            }
          }
        `;
      },
      // 设置默认地址的query
      defaultQuery() {
        return `
          mutation customerDefaultAddressUpdate($addressId: ID!, $customerAccessToken: String!) {
            customerDefaultAddressUpdate(addressId: $addressId, customerAccessToken: $customerAccessToken) {
              customerUserErrors {
                message
                code
              }
              userErrors {
                field
                message
              }
            }
          }
        `;
      },
      // 删除地址的query
      deleteQuery() {
        return `
        mutation customerAddressDelete($customerAccessToken: String!, $id: ID!) {
          customerAddressDelete(customerAccessToken: $customerAccessToken, id: $id) {
            customerUserErrors {
              message
              code
            }
            deletedCustomerAddressId
            userErrors {
              field
              message
            }
          }
        }
        `;
      },
      // 提交地址数据
      async fetchAddress() {
        const query = this.addressQuery();
        const formData = this.handleFormParams();
        const params =
          this.formType === "edit"
            ? {
                address: formData,
                id: this.formData?.id,
                customerAccessToken: this.userToken,
              }
            : {
                address: formData,
                customerAccessToken: this.userToken,
              };
        const { customerAddressUpdate } = await fetchGraphQL(query, params);
        if (this.checkedDefault) {
          await this.fetchSetDefault(customerAddressUpdate.customerAddress);
        }
        if (customerAddressUpdate) {
          this.showSuccessMessage();
          this.goBack();
        }
      },
      // 设置默认地址
      fetchSetDefault(address) {
        const query = this.defaultQuery();
        const params = {
          addressId: address.id,
          customerAccessToken: this.userToken,
        };

        fetchGraphQL(query, params).then((data) => {
          if (data) {
            this.showSuccessMessage();
          }
        });
      },

      // 验证电话号码
      validateTelephone() {
        if (!/^\d*$/.test(this.formData.telephone)) {
          this.errors.telephone = "Telephone number must contain only digits";
        } else {
          delete this.errors.telephone;
        }
      },
      // 选择电话号码
      selectTelephoneCode(country) {
        this.selectedTelephone = country;
        this.showTelephoneDropdown = false;
        this.showSelectTelephone = true;
        this.telPlaceholder = "";
        this.filterTelephone = "";
      },
      // 选择国家
      selectCountryCode(country) {
        this.selectedCountry = country;
        this.showCountryDropdown = false;
        this.showSelectCountry = true;
        this.countryPlaceholder = "";
        this.filterCountry = "";
      },
      // 选择地址
      selectAddress(address) {
        this.formData.address1 = address.description;
        this.searchValue = address.description;
        this.showAddressDropdown = false;
      },
      // 点击外部隐藏下拉框(电话号码)
      handleClickTelOutside(event) {
        const select = this.$el.querySelector(".telephone-select");
        if (select && !select.contains(event.target)) {
          this.showTelephoneDropdown = false;
        }
      },
      // 点击外部隐藏下拉框(国家)
      handleClickCountryOutside(event) {
        const select = this.$el.querySelector(".country-select");
        if (select && !select.contains(event.target)) {
          this.showCountryDropdown = false;
        }
      },
      // 点击外部隐藏下拉框(地址)
      handleClickAddressOutside(event) {
        const select = this.$el.querySelector(".select-address");
        if (select && !select.contains(event.target)) {
          this.showAddressDropdown = false;
        }
      },
      // 过滤列表
      filterList(arr, value) {
        if (!Array.isArray(arr)) {
          return [];
        }
        if (!value || value.trim() === "") {
          return arr;
        }
        return arr.filter((item) => {
          return item.area_name.toLowerCase().includes(value.toLowerCase());
        });
      },
      // 地址补全
      completeAddress() {
        const jsonString = theme.getCookies("userSelected");
        const userSelected = theme.inspectJson(jsonString);
        if (!this.searchValue) return;
        const params = {
          query: this.searchValue,
          country: this.selectedCountry?.iso2_code,
          lang: userSelected?.language,
          cartId: encodeURIComponent(
            `${cartPop?.shopifyCartData?.token || ""}`
          ),
        };
        fetchConnect(this.completeAddressUrl, "POST", params).then(
          (response) => {
            if (!response.error) {
              this.matchAddresses = response.data?.suggestions;
              if (this.matchAddresses && this.matchAddresses?.length > 0) {
                this.showAddressDropdown = true;
              }
            }
          }
        );
      },
      // 防抖处理输入
      handleInput(value, type) {
        if (value !== "") {
          if (type === "country") {
            if (this.showSelectCountry) this.showSelectCountry = false;
          } else if (type === "telephone") {
            if (this.showSelectTelephone) this.showSelectTelephone = false;
          }
        } else {
          this.showSelectCountry = true;
          this.showSelectTelephone = true;
        }
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          if (type === "country") {
            this.filterCountry = value;
          } else if (type === "telephone") {
            this.filterTelephone = value;
            if (this.showSelectTelephone) this.showSelectTelephone = false;
          } else {
            this.searchValue = value;
            this.completeAddress();
          }
        }, 300);
      },
      // 提交地址数据
      submitAddress() {
        this.handleAddParams();
        this.errors = {};
        let isValid = true;
        // Required fields validation
        const requiredFields = [
          "firstName",
          "lastName",
          "address1",
          "country",
          "telephoneCode",
          "telephone",
          "province",
          "city",
          "zip",
        ];
        requiredFields.forEach((field) => {
          if (!this.formData[field] || !this.formData[field].trim()) {
            this.errors[field] = `! Please Enter ${
              field.charAt(0).toUpperCase() + field.slice(1)
            }`;
            isValid = false;
          }
        });

        // Telephone number format validation
        if (!/^\d+$/.test(this.formData.telephone)) {
          this.errors.telephone = "Invalid telephone number format";
          isValid = false;
        }

        if (isValid) {
          // 表单验证通过，可以在这里处理表单提交逻辑
          this.fetchAddress();
        } else {
          console.log("表单验证失败");
        }
      },
      // 根据key和value匹配数组中的数据项
      matchData(arr, key, value) {
        return arr.find((item) => item[key] === value);
      },
      // 编辑地址
      editAddress(address) {
        this.formType = "edit";
        Object.assign(this.formData, address);
        this.selectedCountry = this.matchData(
          this.countries,
          "iso2_code",
          address.countryCode
        );
        this.countryPlaceholder = "";
        this.telPlaceholder = "";
        this.formData.telephoneCode =
          address.phone?.indexOf(" ") !== -1
            ? address.phone?.split(" ")[0]
            : "";
        this.selectedTelephone = this.matchData(
          this.countries,
          "iso3_code",
          this.formData.telephoneCode
        );

        this.formData.telephone = address.phone?.split(" ")[1] ?? address.phone;
        this.showForm = true;
      },
      // 重置表单数据
      resetFormData() {
        Object.keys(this.formData).forEach((key) => {
          this.formData[key] = "";
        });

        // 同时重置相关的状态
        this.selectedCountry = null;
        this.selectedTelephone = null;
        this.countryPlaceholder = "Choose Country";
        this.telPlaceholder = "Telephone Code";
        this.searchValue = "";
      },
      // 点击新建地址
      addAddress() {
        this.resetFormData();
        this.showForm = true;
        this.formType = "add";
        this.checkedDefault = this.defaultId ? false : true;
      },
      // 返回列表
      goBack() {
        this.resetFormData();
        this.showForm = false;
      },
      // 显示确认框
      confirmDelete(address) {
        this.addressToDelete = address;
        this.showDeleteConfirm = true;
        document.body.classList.add("overflow-hidden");
      },

      // 取消删除
      cancelDelete() {
        this.showDeleteConfirm = false;
        this.addressToDelete = null;
        document.body.classList.remove("overflow-hidden");
      },

      // 确认删除
      handleDelete() {
        if (this.addressToDelete) {
          const query = this.deleteQuery();
          const params = {
            id: this.addressToDelete.id,
            customerAccessToken: this.userToken,
          };

          fetchGraphQL(query, params).then((data) => {
            if (data) {
              this.showSuccessMessage();
              this.cancelDelete(); // 关闭确认框
            }
          });
        }
      },
    },
    template: `
      <div class="content-list right-content hidden" id="address-management">
        <div class="flex justify-space-between font-size-20 font-bold">
          <div>Address Management</div>
          <div class="cursor-pointer" v-if="!showForm" @click="addAddress">+ Add Address</div>
        </div>
        <div v-if="showForm">
          <div class="address-form">
            <div class="form-row">
              <div class="form-group half">
                <label for="firstName">First Name<span class="required">*</span></label>
                <input type="text" id="firstName" v-model="formData.firstName" placeholder="First Name">
                <span class="error" v-if="errors.firstName">{{ errors.firstName }}</span>
              </div>
              <div class="form-group half">
                <label for="lastName">Last Name<span class="required">*</span></label>
                <input type="text" id="lastName" v-model="formData.lastName" placeholder="Last Name">
                <span class="error" v-if="errors.lastName">{{ errors.lastName }}</span>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group half">
                <label for="country">Country<span class="required">*</span></label>
                <div class="custom-select country-select">
                  <div class="telephone-code-text flex align-items-center justify-space-between">
                    <input class="n-base-selection-input" v-model="filterCountry" type="text" @focus="showCountryDropdown = true" :placeholder="countryPlaceholder" @input="handleInput($event.target.value, 'country')">
                    <div class="selected-item" :class="showSelectCountry ? 'z-index-show' : 'z-index-hide'" v-show="selectedCountry">
                      <span class="area-name">[{{ selectedCountry?.iso2_code }}]{{ selectedCountry?.area_name }}</span>
                    </div>
                    <span class="icon-caret">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M2 4L6 8L10 4" stroke="currentColor" stroke-width="1.5"/>
                      </svg>
                    </span>
                  </div>
                
                  <div class="select-dropdown" role="listbox" v-show="showCountryDropdown">
                    <div class="select-option" role="option" v-for="(country, index) in filteredCountries" :key="country?.iso2_code || index" :data-value="country.iso2_code" @click="selectCountryCode(country)">
                      <img :src="country.logo" class="country-img">
                      <span class="country-code">[{{ country.iso2_code }}]</span>
                      {{ country.area_name }}
                    </div>
                  </div>
                </div>
                <span class="error" v-if="errors.country">{{ errors.country }}</span>
              </div>
              <div class="form-group half">
                <label for="city">City<span class="required">*</span></label>
                <input type="text" id="city" v-model="formData.city" placeholder="City">
                <span class="error" v-if="errors.city">{{ errors.city }}</span>
              </div>
            </div>
      
            <div class="form-row">
              <div class="form-group half">
                <label for="province">State/Province<span class="required">*</span></label>
                <input type="text" id="province" v-model="formData.province" placeholder="State/Province">
                <span class="error" v-if="errors.province">{{ errors.province }}</span>
              </div>

              <div class="form-group half">
                <label for="telephone">Telephone<span class="required">*</span></label>
                <div class="telephone-input">
                  <div class="custom-select telephone-select">
                    <div class="telephone-code-text flex align-items-center justify-space-between">
                      <input class="n-base-selection-input" type="text" v-model="filterTelephone"  @focus="showTelephoneDropdown = true" :placeholder="telPlaceholder" @input="handleInput($event.target.value, 'telephone')">
                      <div class="selected-item" :class="showSelectTelephone ? 'z-index-show' : 'z-index-hide'">
                        <span class="area-name">{{ selectedTelephone?.iso3_code }}</span>
                      </div>
                      <span class="icon-caret">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path d="M2 4L6 8L10 4" stroke="currentColor" stroke-width="1.5"/>
                        </svg>
                      </span>
                    </div>
                  
                    <div class="select-dropdown" role="listbox" v-show="showTelephoneDropdown">
                      <div class="select-option" role="option" v-for="(country,index) in filteredTelephoneCodes" :key="country?.iso2_code || index" :data-value="country.iso3_code" @click="selectTelephoneCode(country)">
                        <img :src="country.logo" class="country-img">
                        {{ country.area_name }}
                        <span class="country-code">({{ country.iso3_code }})</span>
                      </div>
                    </div>
                  </div>
                  <input
                    type="tel"
                    id="telephone"
                    v-model="formData.telephone"
                    @input="validateTelephone"
                    placeholder="Phone Number"
                  >
                </div>
                <span class="error" v-if="errors.telephone">{{ errors.telephone }}</span>
              </div>
            </div>

            <div class="form-group relative select-address">
              <input type="text" v-model="searchValue" placeholder="ADDRESS FINDER: Search By Postcode, Street Or Address" @input="handleInput($event.target.value, 'address')">
              <div class="select-dropdown" v-show="showAddressDropdown">
                <div class="select-option" v-for="(address, index) in matchAddresses" :key="index" @click="selectAddress(address)">
                  {{ address.description }}
                </div>
              </div>
            </div>
      
            <div class="form-group">
              <label for="address1">Street Address<span class="required">*</span></label>
              <input type="text" id="address1" v-model="formData.address1" placeholder="Street Address">
              <span class="error" v-if="errors.address1">{{ errors.address1 }}</span>
            </div>
      
            <div class="form-group">
              <label for="address2">Apartment Address</label>
              <input type="text" id="address2" v-model="formData.address2" placeholder="Apartment Address">
            </div>
      
            <div class="form-group half">
              <label for="zipCode">Zip Code<span class="required">*</span></label>
              <input type="text" id="zipCode" v-model="formData.zip" placeholder="Zip Code">
              <span class="error" v-if="errors.zip">{{ errors.zip }}</span>
            </div>
            
            <div class="form-group">
              <div class="flex gap-5 align-items-center cursor-pointer" @click="checkedDefault=!checkedDefault">
                <div class="checkbox" :class="defaultFlag() ? 'checked' : ''"><img v-if="defaultFlag()" src="/cdn/shop/t/66/assets/check.png" alt=""></div>
                <span class="active-color">Set as default shipping address</span>
              </div>
            </div>
            <button type="submit" @click="submitAddress">submit</button>
          </div>
          <div @click="goBack" class="underline cursor-pointer font-size-20 font-bold active-color"><< Back</div>
        </div>
        <div v-else>
          <div class="table">
            <div class="table-row table-header">
              <div class="table-cell">Receiver</div>
              <div class="table-cell">Phone</div>
              <div class="table-cell">Address</div>
              <div class="table-cell">Operation</div>
              <div class="table-cell"></div>
            </div>
            <div class="table-row font-size-14 align-items-center" v-for="address in addressList">
              <div class="table-cell">
                {{ address.name }}
              </div>
              <div class="table-cell">
                {{ address.phone }}
              </div>
              <div class="table-cell">{{ address.address1 }},{{ address.province }},{{ address.country }}</div>
              <div class="table-cell">
                <div class="cursor-pointer margin-t-12 flex align-items-center justify-content-center gap-5" @click="editAddress(address)">
                  <svg t="1745392427065" class="icon" viewBox="0 0 1126 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6559" width="18" height="18">
                    <path d="M1037.7216 946.3808c20.6848 0 37.4784 17.408 37.4784 38.8096s-16.7936 38.8096-37.4784 38.8096H88.6784c-20.6848 0-37.4784-17.408-37.4784-38.8096s16.7936-38.8096 37.4784-38.8096h949.0432z m-0.4608-703.6928L442.7776 858.4192l-231.8336 24.4736 23.6544-239.9744L751.5136 107.4176l77.568-80.3328c34.8672-36.096 95.6416-36.096 130.5088 0l77.568 80.3328c17.3568 17.8688 27.0848 42.24 27.0848 67.584 0.1024 25.4464-9.6256 49.8176-26.9824 67.6864zM294.912 796.0576l113.664-12.0832 471.6544-488.5504-102.144-105.7792-471.6544 488.5504-11.52 117.8624zM894.4128 76.8c-4.5568 0-9.0112 1.8944-12.3392 5.2224l-51.0976 52.8896 102.144 105.7792 51.0976-52.8896c3.328-3.4304 5.12-7.936 5.12-12.8 0-4.7104-1.8432-9.3696-5.12-12.8L906.752 81.9712a17.3568 17.3568 0 0 0-12.3392-5.1712z m0 0" fill="#707070" p-id="6560"></path>
                  </svg>
                  <span class="hover-underline">Edit</span>
                </div>
                <div class="cursor-pointer margin-t-12 flex align-items-center justify-content-center gap-5" @click="confirmDelete(address)">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1729151328607" viewBox="0 0 1024 1024" version="1.1" p-id="10018" width="16" height="16" class="icon">
                    <path d="M954.368 133.256533H656.384C652.9024 59.1872 589.6192 0 512.341333 0c-77.346133 0-140.629333 59.1872-144.042666 133.256533H69.632a34.952533 34.952533 0 0 0-35.498667 34.4064c0 18.978133 15.906133 27.170133 35.498667 27.170134h884.736c19.592533 0 35.498667-8.192 35.498667-27.170134a34.952533 34.952533 0 0 0-35.498667-34.4064z m-355.9424 0H431.3088c4.437333-58.026667 42.871467-77.141333 81.032533-77.141333 38.0928 0 80.6912 19.456 86.084267 77.141333z m243.029333 171.690667V962.56H185.002667V304.9472c0-18.978133-3.618133-34.338133-23.210667-34.338133a34.952533 34.952533 0 0 0-35.498667 34.338133v684.714667c0 18.978133 15.906133 34.338133 35.498667 34.338133H865.621333c19.592533 0 35.498667-15.36 35.498667-34.4064V304.9472a34.952533 34.952533 0 0 0-35.498667-34.338133c-19.592533 0-24.098133 15.36-24.098133 34.338133z m-404.343466 530.8416V389.9392c0-27.716267-8.874667-50.107733-28.4672-50.107733-19.6608 0-27.0336 22.391467-27.0336 50.107733v445.8496c0 27.716267 7.3728 50.176 27.0336 50.176 19.592533 0 28.4672-22.528 28.4672-50.176z m212.5824 0V389.9392c0-27.716267-9.0112-50.107733-28.603734-50.107733s-27.784533 22.391467-27.784533 50.107733v445.8496c0 27.716267 8.192 50.176 27.784533 50.176s28.603733-22.528 28.603734-50.176z" fill="#ed5749" p-id="10019"></path>
                  </svg>
                  <span class="active-color hover-underline">Delete</span>
                </div>
              </div>
              <div class="table-cell flex justify-content-center align-items-center flex-wrap">
                <div class="flex gap-5 align-items-center not-allowed" v-if="defaultId == address.id"><div class="checkbox checked"><img src="/cdn/shop/t/66/assets/check.png" alt=""></div>Default shipping address</div>
                <span class="re-order-btn cursor-pointer" @click="fetchSetDefault(address)" v-else>Set as default shipping address</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 删除确认框 -->
        <div class="modal-overlay" v-if="showDeleteConfirm" @click="cancelDelete">
          <div class="modal confirm-modal" @click.stop>
            <div class="modal-header">
              <span>Delete reminder!</span>
              <span class="cursor-pointer" @click="cancelDelete">✕</span>
            </div>
            <div class="modal-main">
              Are you sure to delete this address?
            </div>
            <div class="modal-footer">
              <button class="modal-cancel-button modal-button" @click="cancelDelete">Cancel</button>
              <button class="modal-confirm-button modal-button hairline-left" @click="handleDelete">Confirm</button>
            </div>
          </div>
        </div>
      </div>
    `,
  });

let address = null;
